import { gql } from "@edreamsodigeo/frontend-api-client";

export const MEMBERSHIP_PRODUCT_EVALUATION_MUTATION = gql`
  mutation UpdateMembershipProductEvaluation(
    $request: MembershipProductEvaluationRequest
  ) @silent {
    membershipProductEvaluation(request: $request) {
      code
    }
  }
`;
